import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface UserProfile {
  id: string;
  name: string;
  email: string;
  profileImage?: string;
  preferences?: {
    location?: {
      latitude: number;
      longitude: number;
    };
    interests?: string[];
  };
}

/**
 * Get or create a persistent user ID stored in localStorage
 */
export const getUserId = (): string => {
  const STORAGE_KEY = 'nia_user_id';
  let userId = localStorage.getItem(STORAGE_KEY);

  if (!userId) {
    // Generate a new user ID
    userId = `user_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
    localStorage.setItem(STORAGE_KEY, userId);
  }

  return userId;
};

export const userService = {
  getCurrentUser: async (): Promise<UserProfile | null> => {
    try {
      const response = await api.get('/me');
      return response.data;
    } catch (error: any) {
      console.error('Error fetching user profile:', error);
      return null;
    }
  },

  updateUserProfile: async (profile: Partial<UserProfile>): Promise<UserProfile | null> => {
    try {
      const response = await api.put('/me', profile);
      return response.data;
    } catch (error: any) {
      console.error('Error updating user profile:', error);
      return null;
    }
  },

  uploadProfileImage: async (imageFile: File): Promise<string | null> => {
    try {
      const formData = new FormData();
      formData.append('image', imageFile);
      
      const response = await api.post('/me/avatar', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data.imageUrl;
    } catch (error: any) {
      console.error('Error uploading profile image:', error);
      return null;
    }
  },
};

